import QCTypeModel from '../models/QCTypeModel';
import BaseStore from './BaseStore';

class QCTypeStore extends BaseStore {
  constructor(transportLayer) {
    super(QCTypeModel, transportLayer);
  }
}

export default QCTypeStore;



// WEBPACK FOOTER //
// ./src/stores/QCTypeStore.js